import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Card, InputGroup, Spinner } from 'react-bootstrap';
import { FaUser, FaCheck, FaPercent, FaDollarSign } from 'react-icons/fa';
import { NotificationContext } from '../../contexts/notification-context';
import servicosService from '../../api/servicosService';
import { useNavigate, useParams } from 'react-router-dom';

const CadastrarServico = () => {
  const { addNotification } = React.useContext(NotificationContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const [nome, setNome] = useState('');
  const [valor, setValor] = useState(0);
  const [ativo, setAtivo] = useState(true);
  const [comissaoProfissional, setComissaoProfissional] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      const carregarServico = async () => {
        try {
          setLoading(true);
          const servico = await servicosService.obter(id); 
          setNome(servico.nome);
          setValor(servico.valor);
          setAtivo(servico.ativo);
          setComissaoProfissional(servico.comissaoProfissional);
        } catch (err) {
          console.error('Erro ao carregar serviço:', err);
          addNotification('danger', 'Erro ao carregar serviço. Por favor, tente novamente.');
        } finally {
          setLoading(false);
        }
      };

      carregarServico();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'nome':
        setNome(value);
        break;
      case 'valor':
        setValor(value);
        break;
      case 'ativo':
        setAtivo(value === 'true');
        break;
      case 'comissaoProfissional':
        setComissaoProfissional(value);
        break;
      default:
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!nome || !valor || !comissaoProfissional) {
      addNotification('danger', 'Por favor, preencha todos os campos.');
      setLoading(false);
      return;
    }

    const servicoData = {
      nome,
      valor,
      ativo,
      comissaoProfissional, 
    };

    console.log(servicoData);

    try {
      if (id) {
        await servicosService.atualizar(id, servicoData);
        addNotification('success', 'Serviço alterado com sucesso!');
      } else {
        await servicosService.inserir(servicoData);
        setNome('');
        setValor('');
        setComissaoProfissional('');
        addNotification('success', 'Serviço cadastrado com sucesso!');
      }
      navigate('/servicos'); 
    } catch (err) {
      console.error('Erro ao salvar serviço:', err);
      addNotification('danger', `Erro ao ${id ? 'alterar' : 'cadastrar'} serviço. Por favor, tente novamente.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cadastrar-servico-container">
      <Card className="cadastrar-servico-card shadow-sm">
        <Card.Body>
          <Card.Title className="text-center mb-4">{id ? 'Editar Serviço' : 'Cadastrar Serviço'}</Card.Title>
          <hr />
          <Form onSubmit={handleSubmit} className="cadastrar-servico-form">
            <Row>
              <Col md={6} sm={12}>
                <Form.Group controlId="nome">
                  <Form.Label>Nome</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <FaUser />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="nome"
                      value={nome}
                      onChange={handleChange}
                      required
                      placeholder="Digite o nome do serviço"
                    />
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={3} sm={12}>
                <Form.Group controlId="valor">
                  <Form.Label>Valor</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <FaDollarSign />
                    </InputGroup.Text>
                    <Form.Control
                      type="number"
                      step="0.01"
                      name="valor"
                      value={valor}
                      onChange={handleChange}
                      required
                      placeholder="Digite o valor do serviço"
                    />
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={3} sm={12}>
                <Form.Group controlId="comissaoProfissional">
                  <Form.Label>Comissão Profissional</Form.Label>
                    <InputGroup>
                        <InputGroup.Text>
                            <FaPercent />
                        </InputGroup.Text>
                        <Form.Control
                            type="number"
                            step="0.01"
                            name="comissaoProfissional"
                            value={comissaoProfissional || ''}
                            onChange={(e) => handleChange(e)}
                            required
                        />
                    </InputGroup>
                </Form.Group>
              </Col>
            </Row>
            {id &&
                <Row className='mt-3'>
                <Col md={3} sm={12}>
                    <Form.Group controlId="ativo">
                    <Form.Label>Ativo</Form.Label>
                    <InputGroup>
                        <InputGroup.Text>
                        <FaCheck />
                        </InputGroup.Text>
                        <Form.Control
                        as="select"
                        className="form-select"
                        name="ativo"
                        value={ativo ? 'true' : 'false'}
                        disabled={!id}
                        onChange={handleChange}
                        required
                        >
                        <option value="true">Ativo</option>
                        <option value="false">Inativo</option>
                        </Form.Control>
                    </InputGroup>
                    </Form.Group>
                </Col>
                </Row>
            }
            <Row className="mt-4">
              <Col className="text-start"> 
                  <Button
                  variant="primary"
                  type="submit"
                  disabled={loading}
                  className="me-2"
                  >
                  {loading ? (
                      <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      />
                  ) : (
                      id ? 'Alterar' : 'Cadastrar'
                  )}
                  </Button>
                  <Button variant="secondary" onClick={() => navigate('/lista-servicos')}>
                  Voltar
                  </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default CadastrarServico;
